<template>
  <div class="total-wrapper">
    <the-auth-modal ref="authModal" v-on:logged-in="loggedIn"></the-auth-modal>
    <div v-bind:style="backgroundImage" class="background-image">
      <div class="dark-overlay">
        <div class="container-fluid">
          <img src="../../../static/2024_yarlow_logo.png" alt="logo" class="logo">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TheAuthModal from './TheAuthModal.vue'
import router from '../../router/index.js'

export default {
  metaInfo: {
    title: 'SignIn',
    meta: [
      { vmid: 'description', content: 'Sign in to manage your Yarlow profile.' }
    ]
  },
  components: {
    theAuthModal: TheAuthModal
  },
  data () {
    return {
    }
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/104-night-house.jpg")'
    },
    ...mapGetters('user', [
      'getUserType'
    ]),
    dashboard () {
      if (this.getUserType === 'lender') return '/profile/lender/dashboard'
      if (this.getUserType === 'realtor') return '/profile/realtor/dashboard'
      if (this.getUserType === 'service provider') return '/profile/serviceprovider/dashboard'
      return '/profile/user/dashboard'
    }
  },
  methods: {
    ...mapActions([
      'logOut'
    ]),
    ...mapMutations('loginModal', [
      'updateLoginMode'
    ]),
    loggedIn () {
      router.push(this.dashboard)
    },
    showLoginModal () {
      this.updateLoginMode(true)
      this.$refs.authModal.$refs.authModal.show()
    }
  },
  mounted () {
    this.$global.gaEvent('userViewLandingPage', 'navigation')
    this.showLoginModal()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.logOut()
    })
  }
}
</script>

<style scoped>
.background-image {
  height: 86vh;
  background-size: cover;
  background-position: center center !important;
}

.container-fluid {
  height: 100%;
}

.logo {
  margin-left: 0.5rem;
  margin-top: 0.5rem;
  position: absolute;
  width: 100px;
}

.total-wrapper {
  min-height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/SignInPage.vue